import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export const PublicRoute = ({ isAuthenticated }) => {
	return isAuthenticated ? <Navigate to='/dashboard/ordenes' /> : <Outlet />;
};
